import React, { useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import Pagination from "./pagination";

const Swipeable = ({
    children,
    options,
    onChangeIndexCallback = () => {},
    selectedIndex = 0,
    showSelectedIndex = false,
    onPreviousCallback,
    onNextCallback,
    ...restProps
}) => {
    const [swipeIndex, setSwipeIndex] = useState(0);

    const handleChangeIndex = (index) => {
        setSwipeIndex(index);
        onChangeIndexCallback(index);
    };

    const { enableArrows, enableDots, enablePagination = true, arrowColor, allActive, ...swipeOptions } = options;

    return (
        <React.Fragment>
            <SwipeableViews index={showSelectedIndex ? selectedIndex : swipeIndex} onChangeIndex={handleChangeIndex} {...swipeOptions} {...restProps}>
                {children}
            </SwipeableViews>
            {enablePagination && (
                <Pagination
                    enableArrows={enableArrows}
                    enableDots={enableDots}
                    dots={children.length}
                    index={showSelectedIndex ? selectedIndex : swipeIndex}
                    onChangeIndex={handleChangeIndex}
                    arrowColor={arrowColor}
                    allActive={allActive}
                    onPreviousCallback={onPreviousCallback}
                    onNextCallback={onNextCallback}
                />
            )}
        </React.Fragment>
    );
};

Swipeable.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    options: PropTypes.object,
    onChangeIndexCallback: PropTypes.func,
    selectedIndex: PropTypes.number,
    showSelectedIndex: PropTypes.bool,
    onPreviousCallback: PropTypes.func,
    onNextCallback: PropTypes.func
};

export default Swipeable;
